import React, { ReactElement } from "react";

import { Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import {
  getSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import { validateDuration } from "../../../../validators/duration";
import { SectionProps } from "../../../routes/components/edit_sections/common";

export const Timeouts = ({
  readonly,
  tabValue,
  refresh,
}: SectionProps): ReactElement => {
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          Timeouts
        </Typography>
        <Divider />
        <SettingSection label="Idle Timeout" docsKey="idle-timeout">
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="timeoutIdle"
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>
        <Divider />
        <SettingSection label="Write Timeout" docsKey="write-timeout">
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="timeoutWrite"
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>
        <Divider />
        <SettingSection label="Read Timeout" docsKey="read-timeout">
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="timeoutRead"
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>
        <Divider />
        <SettingSection
          label="Default Upstream Timeout"
          docsKey="default-upstream-timeout"
        >
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="defaultUpstreamTimeout"
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>
      </Stack>
    </Container>
  );
};
